import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavTreeService, VwFlatNavItem } from '../../nav-tree.service';
import { toMaterialIcon } from '../../icon-map';

export interface VwCrumb {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() title: string;
  @Input() crumbs: VwCrumb[] = [];

  hoveredCrumb: VwCrumb = null;
  toMaterialIcon = toMaterialIcon;

  constructor(private router: Router, private navTree: NavTreeService) {}

  goTo(crumb: VwCrumb): void {
    if (crumb.url) { this.router.navigateByUrl(crumb.url); }
  }

  // Other pages at the same sidebar level as this crumb — e.g. hovering
  // "Staff List" on the Add Staff page's breadcrumb offers every other
  // page under that same Staff nav group, not just a link back to the list.
  siblingsFor(crumb: VwCrumb): VwFlatNavItem[] {
    if (!crumb.url) {
      return [];
    }
    return this.navTree.siblingsFor(crumb.url);
  }
}
